/* eslint-disable max-len */
import Icon, { IconProps } from './icon';
import React from 'react';

export const MinusIcon: React.FC<Omit<IconProps, 'children'>> = ({
  size = 16,
  title = 'Minus',
  className,
  ...rest
}) => {
  return (
    <Icon size={size} title={title} viewBox="0 0 16 16" className={className} {...rest}>
      <path
        d="M2.6665 7.99999C2.6665 7.63181 2.96498 7.33333 3.33317 7.33333H12.6665C13.0347 7.33333 13.3332 7.63181 13.3332 7.99999C13.3332 8.36818 13.0347 8.66666 12.6665 8.66666H3.33317C2.96498 8.66666 2.6665 8.36818 2.6665 7.99999Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </Icon>
  );
};
